
export enum TransactionMutationTypes {
    SET_TRANSACTION = 'SET_TRANSACTION',
    SET_BUYER_INFO = 'SET_BUYER_INFO'
}
